// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"2f8dfdcb","237":"89bc590d","418":"cf40720e","533":"adac0df7","539":"ee8c0f3c"}[chunkId] + ".chunk.css";
};